<div class="page-header">
    <div class="page-header-info">{{userInfo?.productType}} {{userInfo?.policyNumber}}</div>
    <div class="page-header-text" *ngIf="!hideLayout">Payment method</div>
</div>

<div class="page-body">
    <!-- <fieldset class="bolt-fieldset bolt--radios" *ngIf="savedPaymentMethods.length">
        <legend>
            <span class="bolt-fieldset__name">
                Use a payment method we have on file for you:
            </span>
        </legend>
        <div class="bolt-fieldset__body">
            <bolt-radio-control *ngFor="let method of savedPaymentMethods; index as i">
                <input id="INPUT_ID_{{i}}" class="radio-input" name="INPUT_GROUP" type="radio" [value]="i+1"/>
                <label for="INPUT_ID_{{i}}">
                    <bolt-radio-facade></bolt-radio-facade>
                    <div class="bolt-field__label">
                        <div class="payment-method-provider">
                            <img src="../../../assets/images/visa.svg" alt="Visa card" />
                        </div>
                        <div class="payment-method-type">{{method.description}}</div>
                        <div class="payment-method-number">{{method.electronicFundsTransfer?.maskedBankAccountNumber}}</div>
                    </div>
                </label>
            </bolt-radio-control>
        </div>
    </fieldset> -->
    <div id="ways2pay-iframe">
        <div></div>
    </div>
</div>

<div class="page-footer" *ngIf="!hideLayout">
    <bolt-button-bar class="footer-button-bar">
        <bolt-button slot="cancel" (click)="onCancel()">Cancel</bolt-button>
        <bolt-button slot="back" (click)="onBack()">Back</bolt-button>
        <!-- <bolt-button slot="forward" type="primary">Review payment details</bolt-button> -->
    </bolt-button-bar>
</div>